'use strict'

var caseSensitiveTransform = require('./case-sensitive-transform')

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/~/property-information/lib/util/case-insensitive-transform.js
// module id = 74
// module chunks = 35783957827783 204390864267482 254791781388126